import React from 'react';
import { StyleSheet, View } from 'react-native';
import Turnstile from 'react-turnstile';
import theme from 'shared/styles/theme';
import getEnvironmentVar from 'shared/utils/getEnvironmentVar';

interface TurnstileProps {
  setXVaroCToken: (token: string) => void;
  xVaroCToken?: string;
}

const VaroTurnstile = ({
  setXVaroCToken,
  xVaroCToken = '',
}: TurnstileProps) => {
  return (
    <View style={styles.turnstileContainer} testID="turnstile-container">
      <Turnstile
        sitekey={getEnvironmentVar('EXPO_TURNSTILE_SITE_KEY')}
        onVerify={(token: string) => {
          if (xVaroCToken === '') {
            setXVaroCToken(token);
          }
        }}
        appearance="execute"
      />
    </View>
  );
};

export default VaroTurnstile;

const styles = StyleSheet.create({
  turnstileContainer: {
    alignItems: 'center',
    gap: theme.spacing.s,
    justifyContent: 'center',
    marginBottom: theme.spacing.m,
  },
});
